import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateFollowUps = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 710.37 509.13",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{fill:#fafcff;}.d,.e{fill:#9ec5ff;}.f{fill:#b5c5ea;}.g{fill:#dcebfe;}.e{fill-rule:evenodd;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "c",
				cx: 363.69,
				cy: 253.26,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M518.12,253.1c0,43.26-18.04,82.28-47.03,109.98-27.29,26.14-64.38,42.2-105.15,42.2s-77.82-16.01-105.15-42.15c-28.99-27.7-47.03-66.73-47.03-110.03,0-84.03,68.11-152.18,152.19-152.18s152.18,68.15,152.18,152.18Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "f",
					d: "M471.09,363.08c-27.29,26.14-64.38,42.2-105.15,42.2s-77.82-16.01-105.15-42.15c6.72-43.72,40.04-78.6,82.88-87.71-22.5-8.88-38.47-30.79-38.47-56.51,0-33.55,27.2-60.74,60.75-60.74s60.75,27.2,60.75,60.74c0,25.72-15.97,47.63-38.52,56.51,42.84,9.11,76.16,43.99,82.93,87.67Z"
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M229.7,27.85H95.46c-4.99,0-9.03,4.04-9.03,9.03V125.78c0,4.99,4.04,9.03,9.03,9.03h74c7.83,13.02,20.9,16.09,27.7,16.78,1.48,.15,2.35-1.63,1.31-2.7-4.79-4.96-6.87-9.86-7.61-14.08h38.84c4.99,0,9.03-4.04,9.03-9.03V36.89c0-4.99-4.04-9.03-9.03-9.03Z"
				}), /* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "d",
						d: "M106.54,79.45h112.07c1.22,0,2.21,.92,2.21,2.05h0c0,1.13-.99,2.05-2.21,2.05H106.54c-1.22,0-2.21-.92-2.21-2.05h0c0-1.13,.99-2.05,2.21-2.05Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "d",
						d: "M106.13,97.92h47.46c.99,0,1.8,.92,1.8,2.05h0c0,1.13-.81,2.05-1.8,2.05h-47.46c-.99,0-1.8-.92-1.8-2.05h0c0-1.13,.81-2.05,1.8-2.05Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "d",
						d: "M106.13,60.98h112.9c.99,0,1.8,.92,1.8,2.05h0c0,1.13-.81,2.05-1.8,2.05H106.13c-.99,0-1.8-.92-1.8-2.05h0c0-1.13,.81-2.05,1.8-2.05Z"
					})
				] })] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M701.34,111.29h-154.24c-4.99,0-9.03,4.04-9.03,9.03v58.89c0,4.99,4.04,9.03,9.03,9.03h34.46c-7.83,13.02-20.9,16.09-27.7,16.78-1.48,.15-2.35-1.63-1.31-2.7,4.79-4.96,6.87-9.86,7.61-14.08h141.18c4.99,0,9.03-4.04,9.03-9.03v-58.89c0-4.99-4.04-9.03-9.03-9.03Z"
				}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M562.33,157.53h82.07c1.22,0,2.21,.92,2.21,2.05h0c0,1.13-.99,2.05-2.21,2.05h-82.07c-1.22,0-2.21-.92-2.21-2.05h0c0-1.13,.99-2.05,2.21-2.05Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M561.92,139.06h112.9c.99,0,1.8,.92,1.8,2.05h0c0,1.13-.81,2.05-1.8,2.05h-112.9c-.99,0-1.8-.92-1.8-2.05h0c0-1.13,.81-2.05,1.8-2.05Z"
				})] })] }),
				/* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M122.01,121.69H28.32c-4.33,0-7.85,3.51-7.85,7.85v46.19c0,4.33,3.51,7.85,7.85,7.85h55.47c8.87,8.87,16.44,10.54,22.34,11.15,1.29,.13,2.04-1.42,1.14-2.35-4.16-4.31-4.25-5.14-4.89-8.8h19.63c4.33,0,7.85-3.51,7.85-7.85v-46.19c0-4.33-3.51-7.85-7.85-7.85Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M261.4,405.28h-123.69c-4.33,0-7.85,3.51-7.85,7.85v36.19c0,4.33,3.51,7.85,7.85,7.85h85.47c8.87,8.87,16.44,10.54,22.34,11.15,1.29,.13,2.04-1.42,1.14-2.35-4.16-4.31-4.25-5.14-4.89-8.8h19.63c4.33,0,7.85-3.51,7.85-7.85v-36.19c0-4.33-3.51-7.85-7.85-7.85Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M561.47,272.51h77.78c3.6,0,6.52,2.92,6.52,6.52v38.35c0,3.6-2.92,6.52-6.52,6.52h-46.05c-7.37,7.37-13.65,8.75-18.55,9.25-1.07,.11-1.69-1.18-.95-1.95,3.45-3.58,3.53-4.27,4.06-7.31h-16.29c-3.6,0-6.52-2.92-6.52-6.52v-38.35c0-3.6,2.92-6.52,6.52-6.52Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M177.63,295.7h-43.27c-.02-.08-.03-.16-.06-.23l-7.04-18.79c-.58-1.56-2.79-1.56-3.38,0l-7.04,18.79c-.03,.08-.04,.16-.06,.23h-43.27c-12.11,0-21.92,9.81-21.92,21.92h0c0,12.11,9.81,21.92,21.92,21.92h104.12c12.11,0,21.92-9.81,21.92-21.92h0c0-12.11-9.81-21.92-21.92-21.92Z"
				}), /* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("circle", {
						className: "d",
						cx: 125.57,
						cy: 317.62,
						r: 5.97
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "d",
						cx: 93.64,
						cy: 317.62,
						r: 5.97
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "d",
						cx: 157.51,
						cy: 317.62,
						r: 5.97
					})
				] })] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M527.62,484.49c-.02-.06-.04-.12-.06-.18,4.42-6.17,7.02-13.73,7.02-21.9,0-20.79-16.86-37.65-37.65-37.65s-37.65,16.86-37.65,37.65,16.86,37.65,37.65,37.65c8.12,0,15.63-2.57,21.78-6.94l9.73,5.74c1.31,.77,2.9-.43,2.51-1.9l-3.33-12.47Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M516,471.66l-8.23-4.23c-.33-.11-.78-.11-1.11,.22l-3.34,3.34c-.33,.33-.67,.44-1.11,.22-5.12-2.34-10.45-7.67-12.9-12.9-.11-.33,0-.67,.22-1l3.45-3.45c.22-.22,.33-.67,.11-1l-4.23-8.23c-.22-.56-.78-.67-1.22-.44-1.89,1-3.45,2.22-4.67,3.56-2.67,2.89-3.34,6.67-2,10.23,4,10.56,11.12,17.68,21.69,21.69,3.56,1.33,7.34,.56,10.23-2,1.33-1.22,2.56-2.78,3.56-4.67,.22-.44,0-1-.44-1.33h0Z"
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("circle", {
					className: "g",
					cx: 564.2,
					cy: 38.35,
					r: 28.01
				}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M562.19,48.19h-12.24v-2.1l5.49-6.88c1.07-1.34,2.13-2.9,2.13-5.05,0-1.99-.71-4.23-3.03-4.23-.66,0-1.64,.41-1.64,1.15,0,.66,1.26,.76,1.26,2.43,0,1.2-.87,2.02-2.05,2.02-1.42,0-2.24-1.12-2.24-2.49,0-2.59,2.7-4.53,6.04-4.53,3.5,0,6.31,2.21,6.31,5.35,0,2.7-1.94,4.15-4.12,5.87-.85,.68-3.25,2.43-4.83,4.51h5.82c1.56,0,1.64-.6,1.72-1.01,.14-.71,.38-.74,1.39-.74v5.71Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M575.96,28.99v12.21h2.57v1.53h-2.57v2.57c0,1.12,.36,1.31,.87,1.37,.66,.08,.71,.33,.71,1.53h-7.48v-.71c0-.6,.35-.71,.71-.79,.55-.14,.87-.38,.87-1.39v-2.57h-6.83v-1.53l8.11-12.21h3.03Zm-4.31,4.73l-4.97,7.48h4.97v-7.48Z"
				})] })] })
			]
		})
	]
});
export default SvgEmptyStateFollowUps;
